import { render, staticRenderFns } from "./ReleaseDetails.vue?vue&type=template&id=2ee8aac8&scoped=true"
import script from "./ReleaseDetails.vue?vue&type=script&lang=js"
export * from "./ReleaseDetails.vue?vue&type=script&lang=js"
import style0 from "./ReleaseDetails.vue?vue&type=style&index=0&id=2ee8aac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee8aac8",
  null
  
)

export default component.exports